<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { WorkCalendar } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import EditWorkCalendar from './EditWorkCalendar.vue';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        workCalendar: WorkCalendar;
    }

    defineProps<Props>();

    const { hasPermission } = usePermissions();
</script>

<template>
    <DataTableActions :data="workCalendar">
        <EditWorkCalendar
            v-if="hasPermission(Permission.WORK_CALENDARS_UPDATE)"
            :workCalendar="workCalendar"
        />
        <Delete
            v-if="hasPermission(Permission.WORK_CALENDARS_DELETE)"
            :route="route('v2.salary.work-calendars.destroy', workCalendar.id)"
            :query-key="[QueryKey.WORK_CALENDARS]"
            header="work-calendars.delete.title"
            description="work-calendars.delete.content"
        />
    </DataTableActions>
</template>
